import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { ExpandedTooltip, Icon, toast } from '@livable/saas-react-components';
import { Button, IconButton, TextField } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import PlainInputTooltip from 'src/components/general/PlainInputTooltip';
import useStyles from './styles';
import { FilePreviewModal } from '../FilePreviewModal';
import { RemoveFileModal } from '../RemoveFileModal';
export default function DumbFileUploader(_ref) {
  let _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? undefined : _ref$icon,
    callback = _ref.callback,
    downloadName = _ref.downloadName,
    tooltipText = _ref.tooltipText,
    filePreviewLink = _ref.filePreviewLink;
  const classes = useStyles();
  const inputRef = useRef(null);
  const _useState = useState(downloadName ? downloadName : ''),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  const _useState3 = useState(downloadName ? true : false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDeleteButton = _useState4[0],
    setIsDeleteButton = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFilePreviewModalOpen = _useState6[0],
    setIsFilePreviewModalOpen = _useState6[1];
  const handleFileUpload = e => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].size >= 1048576 * 100) {
        // NOTE: base is 1MB * 100
        toast('error', {
          body: ['File is too large, maximum file size is 100 MB']
        });
        return;
      }
      setIsDeleteButton(true);
      setValue(e.target.files[0].name);
      if (typeof callback === 'function') {
        callback(e.target.files[0]);
      }
    }
  };
  const handleDelete = () => {
    setValue('');
    setIsDeleteButton(false);
    inputRef.current.querySelector('input').value = null;
    if (typeof callback === 'function') {
      callback(null);
    }
  };
  useEffect(() => {
    setValue(downloadName ? downloadName : '');
    setIsDeleteButton(downloadName ? true : false);
  }, [downloadName, filePreviewLink]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.fileUploaderWrapper
  }, downloadName === '' || filePreviewLink === '' ? /*#__PURE__*/React.createElement("div", {
    className: classes.startIcon
  }, icon || /*#__PURE__*/React.createElement(Icon, {
    type: "file-add"
  })) : /*#__PURE__*/React.createElement("div", {
    className: classes.startPreviewIcon
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: 'Preview file'
  }, /*#__PURE__*/React.createElement(IconButton, {
    onClick: () => {
      setIsFilePreviewModalOpen(!isFilePreviewModalOpen);
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "link"
  })))), /*#__PURE__*/React.createElement(TextField, {
    label: label,
    type: "file",
    ref: inputRef,
    inputProps: {
      style: {
        opacity: '0',
        cursor: 'pointer'
      }
    },
    InputProps: {
      endAdornment: tooltipText ? /*#__PURE__*/React.createElement(PlainInputTooltip, {
        tooltipText: tooltipText
      }) : null
    },
    InputLabelProps: {
      shrink: !!value
    },
    onChange: handleFileUpload,
    fullWidth: true
  }), value && /*#__PURE__*/React.createElement("div", {
    className: classes.fileName
  }, value), isDeleteButton && /*#__PURE__*/React.createElement(RemoveFileModal, {
    callback: handleDelete,
    trigger: /*#__PURE__*/React.createElement(Button, {
      state: "white",
      variant: "actionIcon",
      className: classes.deleteButton,
      'custom-attribute': '316-DumbFileUploader'
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "delete"
    }))
  }), /*#__PURE__*/React.createElement(FilePreviewModal, {
    docUri: filePreviewLink,
    fileName: downloadName,
    isOpen: isFilePreviewModalOpen,
    handleClose: () => setIsFilePreviewModalOpen(!isFilePreviewModalOpen),
    handleOpen: () => setIsFilePreviewModalOpen(!isFilePreviewModalOpen)
  }));
}
DumbFileUploader.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.node
};